/*
 * @providesModule MergeAccountCardStyle
 *
 */

import SkillzStyle from 'SkillzStyle';
import {Platform, StyleSheet} from 'react-native';

export default StyleSheet.create({
  avatarView: {
    marginVertical: 8,
    left: 8,
  },
  avatarViewImage: {
    height: 48,
    width: 48,
    borderRadius: 24,
  },
  container: {
    flexDirection: 'row',
    width: 340,
    height: 64,
    borderRadius: 60,
    backgroundColor: '#FFFFFF',
    alignSelf: 'center',
    ...Platform.select({
      android: {
        elevation: 14,
      },
      ios: {
        shadowColor: 'rgba(0, 0, 0, 0.08)',
        shadowOffset: {width: 0, height: 0},
        shadowRadius: 14,
        shadowOpacity: 1,
      },
      web: {
        shadowColor: 'rgba(0, 0, 0, 0.08)',
        shadowOffset: {width: 0, height: 0},
        shadowRadius: 14,
        shadowOpacity: 1,
      },
    }),
    marginBottom: 8,
  },

  newContainer: {
    flexDirection: 'row',
    padding: 12,
    width: '90%',
    // height: 64,
    borderRadius: 12,
    backgroundColor: 'rgba(0, 0, 0, 0.30)',
    alignSelf: 'center',
    marginBottom: 8,
  },

  currencyIcon: {
    height: 12,
    width: 12,
    alignSelf: 'center',
  },

  newCurrencyIcon: {
    height: 14,
    width: 14,
    alignSelf: 'center',
  },

  currencyText: {
    fontSize: 13,
    color: '#3CBE33',
    marginLeft: 4,
    fontFamily: 'OpenSans-Regular',
    fontWeight: '600',
  },

  newCurrencyText: {
    fontSize: 12,
    color: SkillzStyle.fullStyles.textColorPrimary.color,
    marginLeft: 4,
    ...SkillzStyle.fullStyles.fontBold,
  },

  leftContainer: {
    left: 16,
    top: 16,
    width: '50%',
  },

  mergeIcon: {
    height: 19,
    width: 19,
    right: 0,
    position: 'absolute',
  },

  newMergeIcon: {
    height: 20,
    width: 20,
    right: 0,
    position: 'absolute',
  },

  mergeText: {
    color: '#848484',
    fontSize: 12,
    fontWeight: '700',
    right: 27,
    top: 1,
  },

  newMergeText: {
    color: SkillzStyle.fullStyles.textColorPrimary.color,
    fontSize: 16,
    ...SkillzStyle.fullStyles.fontBold,
    right: 27,
    top: 1,
  },

  primaryText: {
    color: '#4C8500',
    fontSize: 12,
    ...SkillzStyle.fullStyles.fontBold,
    right: 24,
    top: 1,
  },

  newPrimaryText: {
    color: SkillzStyle.fullStyles.textColorPrimary.color,
    ...SkillzStyle.fullStyles.fontBold,
    fontSize: 16,
    right: 24,
    top: 1,
  },

  primaryIcon: {
    height: 16,
    width: 16,
    right: 0,
    position: 'absolute',
  },

  newPrimaryIcon: {
    height: 20,
    width: 20,
    right: 0,
    position: 'absolute',
  },

  rightContainer: {
    position: 'absolute',
    right: 24,
    alignSelf: 'center',
  },

  userName: {
    fontSize: 14,
    fontFamily: 'OpenSans-Regular',
    color: '#1d1d1d',
    fontWeight: '600',
  },

  newUserName: {
    ...SkillzStyle.fullStyles.fontRegular,
    ...SkillzStyle.fullStyles.fontBold,
    fontSize: 16,
    color: SkillzStyle.fullStyles.textColorPrimary.color,
    width: '80%',
  },

  currencyView: {
    flexDirection: 'row',
  },
});
